export default "__VITE_ASSET__CIEh_QPU__"